import React, { useEffect } from "react";
import { Autocomplete, Button, Grid, Paper, Toolbar } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import { Link, useParams } from "react-router-dom";
import CommonForm from "../../utils/components/commonForm";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import { BASE_URL } from "../../global";

const EditService = () => {
  const [inputStates, setInputStates] = React.useState({});
  const [transformerData, setTransformerData] = React.useState([]);
  const params = useParams();

  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
  };

  const handleSubmit = () => {
    let url = BASE_URL;
    if (params.id) {
      axiosWithToken
        .patch(url + `partsAndServices/${params.id}`, inputStates)
        .then((res) => {
          setTimeout(refresh, 500);
          toast("Service edit successfully !");
        })
        .catch((error) => {
          toast.error("Something Went Wrong!");
        });
    } else {
      axiosWithToken
        .post(url + "partsAndServices", inputStates)
        .then((res) => {
          setTimeout(refresh, 500);
          toast("Service created successfully !");
        })
        .catch((error) => {
          toast.error("Something Went Wrong!");
        });
    }
  };

  const fetchpartsAndServices = (inpt) => {
    let url = BASE_URL;
    axiosWithToken
      .get(url + `partsAndServices/${params.id}`)
      .then((res) => {
        let dataObject = res.data[0];

        let newData = {
          ...inputStates,
          ...dataObject,
        };
        dataObject && setInputStates(newData);
      })
      .catch((error) => {
        toast.error("Something Went Wrong!");
      });
  };

  const fetchTransformerData = () => {
    let url = BASE_URL;
    let SQLQuery = {
      query: `SELECT transformerTypes.*, clients.name AS clientName FROM transformerTypes LEFT JOIN clients ON transformerTypes.clientId = clients.id`,
    };

    axiosWithToken
      .post(url + `dynamic`, SQLQuery)
      .then((res) => {
        setTransformerData(res.data);
      })
      .catch((error) => {
        toast.error("Something Went Wrong!");
      });
  };

  var refresh = () => {
    window.location.reload(false);
  };

  useEffect(() => {
    if (params.id) fetchpartsAndServices();
  }, [params.id]);

  useEffect(() => {
    fetchTransformerData();
  }, []);

  const inputFields = [
    {
      type: "Autocomplete",
      label: "Transformer Capacity",
      stateKey: "transformerId",
      valueKey: "id",
      options: transformerData,
      getOptionLabelKey: "transformerCapacity",
      secondOptionLabelKey: "clientName",
    },
    {
      type: "Autocomplete",
      label: "Part Name",
      stateKey: "partId",
      valueKey: "id",
      options: "parts",
      getOptionLabelKey: "name",
    },
    { type: "TextField", label: "SI.No", stateKey: "siNo" },
    { type: "TextField", label: "HSN No.", stateKey: "hsnCode" },
    { type: "TextField", label: "Rate", stateKey: "rate" },
    { type: "TextField", label: "CGST Rate", stateKey: "cgst" },
    { type: "TextField", label: "SGST Rate", stateKey: "sgst" },
    {
      type: "TextField",
      label: "Metal part scrap rate",
      stateKey: "metalScrapRate",
    },
    {
      type: "TextField",
      label: "CGST Rate on Scrap",
      stateKey: "cgstScrapRate",
    },
    {
      type: "TextField",
      label: "SGST Rate on Scrap",
      stateKey: "sgstScrapRate",
    },
    {
      type: "TextField",
      label: "Damaged metal part weight",
      stateKey: "damagedMetalPart",
    },
  ];

  return (
    <>
      <Paper sx={{ mt: 2, p: 4 }}>
        <CommonForm
          inputStates={inputStates}
          updateInputObject={updateInputObject}
          inputFields={inputFields}
        />

        <Toolbar
          style={{
            padding: "0px",
            overflow: "auto",
            display: "flex",
            justifyContent: "end",
          }}
        >
          <Button
            variant="contained"
            size="small"
            sx={{ m: 0 }}
            onClick={() => {
              handleSubmit();
            }}
          >
            {params.id ? "Update" : "Save"}
          </Button>
        </Toolbar>
      </Paper>
    </>
  );
};

export default EditService;
